// extracted by mini-css-extract-plugin
export default {"referral-widget":"zm","referral-page":"Am","label":"Bm","subHed":"Cm","profile-container":"Em","referral-container":"Fm","referral-header":"Gm","shareMethodRow":"Hm","shareMethod":"Im","active":"Jm","referral-stat":"Km","blockwrapper":"Lm","referralLink":"Mm","bold":"Nm","semibold":"Om","shareAgainButton":"Pm","policy":"Qm","narrowWrapper":"Rm"};
    if(module.hot) {
      // 1713211511486
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  